/* global window */
import axios from 'axios'
import Plyr from 'plyr'

window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.initPlayer = (id) => new Plyr(id)
